import { Container, Group, Tabs } from "@mantine/core"
import { PageLink } from "@tfg/ui"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { ActivitiesProvider } from "~/components/contexts/useActivitiesContext"
import { ProdSiteFieldDefsAdminWrapper } from "~/pages/Admin/MasterLists/ProductionSiteFieldDefinitions"

import { CertificatesTypesAdminWrapper } from "./CertificatesTypes"
import { CustomFieldsAdminWrapper } from "./CustomFields"
import { MaterialTypesAdminWrapper } from "./MaterialTypes"
import { ProductTypesAdminWrapper } from "./ProductTypes"

export const MasterLists = () => {
  const { t } = useTranslation("admin")
  const [activeTab, setActiveTab] = useState<string | null>("productTypes")

  const pages = useMemo<PageLink[]>(
    () => [
      {
        label: t("tabs.productTypes"),
        link: "productTypes",
      },
      {
        label: t("tabs.materialTypes"),
        link: "materialTypes",
      },
      {
        label: t("tabs.certificatesTypes"),
        link: "certificatesTypes",
      },
      {
        label: t("tabs.customFields"),
        link: "customFields",
      },
      {
        label: t("tabs.prodSiteFields"),
        link: "prodSiteFields",
      },
    ],
    [t]
  )
  return (
    <ActivitiesProvider>
      <Group gap="xl" miw={100}>
        <Tabs
          value={activeTab}
          onChange={(newValue) => setActiveTab(newValue)}
          style={{ width: "100%" }}
        >
          {!!pages?.length && (
            <>
              <Tabs.List>
                {pages
                  .filter((p) => !p.wip)
                  .map((page) => (
                    <Tabs.Tab key={page.link} value={page.link}>
                      {page.label}
                    </Tabs.Tab>
                  ))}
              </Tabs.List>
            </>
          )}
          {activeTab ? (
            <Container fluid py="md" px="md">
              <Tabs.Panel value={activeTab} key={activeTab}>
                {activeTab === "materialTypes" ? (
                  <MaterialTypesAdminWrapper />
                ) : null}
                {activeTab === "productTypes" ? (
                  <ProductTypesAdminWrapper />
                ) : null}
                {activeTab === "certificatesTypes" ? (
                  <CertificatesTypesAdminWrapper />
                ) : null}
                {activeTab === "customFields" ? (
                  <CustomFieldsAdminWrapper />
                ) : null}
                {activeTab === "prodSiteFields" ? (
                  <ProdSiteFieldDefsAdminWrapper />
                ) : null}
              </Tabs.Panel>
            </Container>
          ) : null}
        </Tabs>
      </Group>
    </ActivitiesProvider>
  )
}
